const mapFailuresToAlertLabels = (failures, errorLabelMap, fallbackLabelKey)=>{
    let errorCodes = [];
    if (failures && failures.length) {
        errorCodes = failures.reduce((acc, failure)=>{
            if (failure.__typename && errorLabelMap[failure.__typename]) {
                return [
                    ...acc,
                    errorLabelMap[failure.__typename]
                ];
            } else {
                return [
                    ...acc,
                    {
                        type: 'error',
                        title: failure.message || fallbackLabelKey
                    }
                ];
            }
        }, errorCodes);
    }
    return errorCodes;
};

export { mapFailuresToAlertLabels };
//# sourceMappingURL=map-failures-to-alert-labels.js.map
